(function() {
  var StageKo;

  StageKo = App.loadClass("grower::viewmodels/nitrogen/Stage");

  exports.Form = function(handler, data, validator) {
    var ref, self, stages;
    self = this;
    this.addStage = function() {
      validator.stopValidating();
      self.stages.push(new StageKo(self, {}, validator));
      return validator.startValidating();
    };
    this.deleteStage = function(stage) {
      if (self.stages().length > 1) {
        self.stages.remove(stage);
        return self.deleted_stages.push(stage);
      }
    };
    this.showDelete = function() {
      return self.stages().length > 1;
    };
    this.getHandler = function() {
      return handler;
    };
    this.getSource = function(sourceid) {
      return handler.taffyObjects.sources().filter({
        id: {
          '==': sourceid
        }
      }).first();
    };
    self.editing = ko.observable(false);
    stages = $.map(data, function(item) {
      return new StageKo(self, item, validator);
    });
    if (stages.length === 0) {
      stages = [new StageKo(self, {}, validator)];
    }
    stages = stages.reverse();
    this.stages = ko.observableArray(stages != null ? stages : []);
    this.deleted_stages = ko.observableArray([]);
    this.year = handler.loadLayoutPostOptions.year;
    this.fields_id = handler.loadLayoutPostOptions.fields_id;
    this.layers_id = (ref = handler.loadLayoutPostOptions.id) != null ? ref : null;
    this.total = ko.computed(function() {
      var i, k, len, ref1, total, v;
      total = 0;
      ref1 = self.stages();
      for (k = i = 0, len = ref1.length; i < len; k = ++i) {
        v = ref1[k];
        total += v.pounds();
      }
      return total;
    });
    return this;
  };

}).call(this);
